/* eslint-disable react/prop-types */
import { BackButton } from './back-button';
import { ContinueButton } from './continue-button';

/**
 * 底部按钮列表
 * @param {Object} options
 * @param {Boolean} options.isContinueDisabled continue 按钮是否 disable
 * @param {Boolean} options.isContinueLoading continue 按钮是否 loading
 * @param {String} options.continueText continue 按钮的文案
 * @param {Boolean} options.showContinueIcon continue 按钮是否显示图标
 * @param {Function} options.onClickContinue 点击 continue 按钮事件
 * @param {Function} options.onClickBack 点击返回按钮事件
 */
export const BottomButtons = ({
  isContinueDisabled = false,
  isContinueLoading = false,
  continueText = 'Continue',
  showContinueIcon = true,
  backText = 'Back',
  showBackIcon = true,
  onClickContinue,
  onClickBack,
}) => (
  <section style={{
    marginTop: '20PX',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
  }}
  >
    <BackButton
      onClickBack={onClickBack}
      showIcon={showBackIcon}
      text={backText}
    />
    <ContinueButton
      disabled={isContinueDisabled}
      isLoading={isContinueLoading}
      onClick={onClickContinue}
      text={continueText}
      showIcon={showContinueIcon}
      id="bottom_continue"
    />
  </section>
);
